var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loaderWrapper"},[_c('pulse-loader',{attrs:{"loading":_vm.showLoader,"color":_vm.siteSettings.accent,"size":"25px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }